import { createSlice } from "@reduxjs/toolkit";

const initialState = { configData: "" };

export const configRecetas = createSlice({
    name: "configRecetaData",
    initialState,
    reducers: {
        configRecetaData: (state, action) => {
            const {data} = action.payload;
            state.configData = data;
        },
    }
})


export const { configRecetaData } = configRecetas.actions;

export default configRecetas.reducer;